module.exports = __webpack_public_path__ + "media/icons/speech-bubble-square-357395a8.svg";